import '@vfde-brix/multidivider/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/promo-price/dist/styles.css';
import { createMultidividerComponent } from '@vfde-brix/multidivider';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-multidivider', createMultidividerComponent, NO_PATTERN_BUSINESS_LOGIC);
